import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useProjectCustomFields, useProjectFieldByName } from 'utils/project-fields/use-project-fields';
import { getDynamicConditionFields } from '../utils';
import { useActiveTemplateId } from './use-active-project-template';
const getProjectDynamicTemplateConditions = ()=>createSelector((state)=>state.templates.project.data, (_, { templateId })=>({
            templateId
        }), (data, { templateId })=>data[templateId].dynamicConditions);
export const useProjectDynamicTemplateConditions = ()=>{
    const templateId = useActiveTemplateId();
    const projectDynamicConditions = useMemo(getProjectDynamicTemplateConditions, []);
    return useSelector((state)=>projectDynamicConditions(state, {
            templateId
        }));
};
export const useDynamicConditionFields = ()=>{
    const { data: projectCustomFields } = useProjectCustomFields();
    // ARR/Project Fee are excluded from `projectCustomFields` (they're native
    // fields, not custom ones) and are otherwise injected as always-enabled
    // synthetic fields — look up their real per-tenant enabled state so the
    // dropdown respects Settings > Project fields for them too.
    const arrField = useProjectFieldByName('annualizedRecurringRevenue');
    const projectFeeField = useProjectFieldByName('projectFee');
    return useMemo(()=>getDynamicConditionFields(projectCustomFields, true, {
            arr: (arrField === null || arrField === void 0 ? void 0 : arrField.isEnabled) !== false,
            projectFee: (projectFeeField === null || projectFeeField === void 0 ? void 0 : projectFeeField.isEnabled) !== false
        }), [
        projectCustomFields,
        arrField,
        projectFeeField
    ]);
};
